/**
 * De focusring van het huis, letterlijk overgenomen uit `Button` in `@xxtract/ui`.
 *
 * `globals.css` zet `*:focus-visible { outline: none }` en geeft alleen een rand en een gloed van
 * tien procent terug. Een element zónder rand — de uitklapknop op een veldrij, de link in een
 * voorbeeld — houdt daar niets zichtbaars van over, en dan weet wie met het toetsenbord werkt niet
 * waar hij staat. Elke bediening in deze module voert daarom dezelfde ring als de knoppen elders in
 * het portaal.
 *
 * `ring-2!` (important): die globale regel staat buiten elke cascadelaag en wint daardoor van een
 * Tailwind-utility. Zonder `!` vervangt zijn `box-shadow` de ring door de gloed van tien procent, en is
 * de focus in heel Werkkwaliteit nauwelijks te zien. Alleen de schaduw van de ring krijgt voorrang;
 * andere modules houden de globale regel.
 */
export const FOCUSRING =
  'focus-visible:outline-none focus-visible:ring-2! focus-visible:ring-[var(--secondary)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--background)]';
